// This file is auto-generated - any changes will be lost

// Page Files
import "../../src/js/pages/AboutUsPage.js";
import "../../src/js/pages/GetInTouchPage.js";
import "../../src/js/pages/HowWeWork.js";
import "../../src/js/pages/Index.js";
import "../../src/js/pages/NewsInner.js";
import "../../src/js/pages/NewsPage.js";
import "../../src/js/pages/Services.js";